module.exports = __webpack_public_path__ + "media/images/bg-cover-1091159e445a3c539b821af319b17008.png";